import { SxProps } from '@mui/material';
import { defaultContainerStyling } from '../../styles/sxStyling';

export const tableContainerSx: SxProps = { overflow: 'visible' };
export const tableWrapperContainerSx: SxProps = {
  ...defaultContainerStyling,
  overflow: 'visible',
};
export const tableWrapperSx: SxProps = {
  display: 'flex',
  alignItems: 'start',
  width: '100%',
  position: 'relative',
  borderRadius: 3,
  overflow: 'hidden',
  border: '1px solid var(--border-color)',
};

export const droppableRowSx = {
  display: 'flex',
  flex: 1,
  overflowX: 'auto',
  minWidth: 0,
};

export const columnBoxSx = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  borderRight: '1px solid rgb(251, 251, 251)',
  backgroundColor: '#fff',
};

export const sortTableCellSx = {
  borderRight: '1px solid rgb(251, 251, 251)',
  '&:hover .drag-icon': {
    visibility: 'visible',
  },
};

export const sortCellInnerSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  cursor: 'pointer',
};

export const dragIconSx = {
  minWidth: 20,
  display: 'flex',
  alignItems: 'center',
  mr: 1,
};

export const swapIconSx = {
  display: 'flex',
  alignItems: 'center',
  minWidth: 20,
  ml: 0.5,
  visibility: 'hidden',
};
